import React from "react";
import "./RetryComponent.css"; // Import the CSS file

const RetryComponent = ({ onRetry = () => {} }) => {
  return (
    <div className="retry-container">
      <h2 className="retry-title ng_h_1_r">Something went wrong</h2>
      <p className="retry-message ng_h_4_r">Please try again.</p>
      <button className="retry-button ng_btn_1_r" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
};

export default RetryComponent;
